const getAllLevels = state => {
  return state.levels
}

const getApartmentByNumber =  (state) => (number) => {
  return state.apts.find(apt => apt.name == number)
}

const getTypicalFromNumber = (state) => (number) => {
  var typical = [{
      '101':'2U.1',
      '102':'1M.1',
      '103':'2AA',
      '104':'2BB',
      '105':'1Q',
      '106':'1Q',
      '107':'1Q',
      '108':'2X.1',
      '109':'2W.1',
      '110':'2Y.1',
      '111':'2Z',
      '201':'2U.1',
      '202':'1M.1',
      '203':'2BB.1',
      '204':'2AA.1',
      '205':'2V.1',
      '206':'2V.2',
      '207':'2V.1',
      '208':'2V.2',
      '209':'2W.2',
      '210':'2X.2',
      '211':'2Y.1',
      '212':'2Z',
      '301':'2U.1',
      '302':'1M.1',
      '303':'2AA',
      '304':'2BB',
      '305':'2V.1',
      '306':'2V.2',
      '307':'2V.1',
      '308':'2V.2',
      '309':'2X.1',
      '310':'2W.1',
      '311':'2Y.1',
      '312':'2Z',
      '401':'2U.1',
      '402':'1M.1',
      '403':'2BB.1',
      '404':'2AA.1',
      '405':'2V.1',
      '406':'2V.2',
      '407':'2V.1',
      '408':'2V.2',
      '409':'2W.2',
      '410':'2X.2',
      '411':'2Y.1',
      '412':'2Z',
      '501':'2U.1',
      '502':'1M.1',
      '503':'2AA',
      '504':'2BB',
      '505':'2V.1',
      '506':'2V.2',
      '507':'2V.1',
      '508':'2V.2',
      '509':'2X.1',
      '510':'2W.1',
      '511':'2Y.1',
      '512':'2Z',
      '1':'2U',
      '2':'1M',
      '3':'1N.1',
      '4':'1N',
      '5':'1N',
      '6':'1O',
      '7':'2V',
      '8':'2W',
      '9':'2X',
      '10':'2Y',
      '11':'1P'
  }];

  return typical[0][number]
}

const getApartmentsByLevel = (state) => (level) => {
  return state.apts.filter(apt => apt.level == level)
}




export default {
  getAllLevels,
  getApartmentByNumber,
  getApartmentsByLevel,
  getTypicalFromNumber
}